import type { SVGProps } from "react";

export function IconBlackPartnerships(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.8335 14.75C16.8335 18.7541 13.5876 22 9.5835 22C5.57943 22 2.3335 18.7541 2.3335 14.75C2.3335 10.7459 5.57943 7.5 9.5835 7.5C13.5876 7.5 16.8335 10.7459 16.8335 14.75Z"
        stroke="#0B0C17"
        strokeWidth="1.5"
      />
      <path
        d="M22.3335 9.25C22.3335 13.2541 19.0876 16.5 15.0835 16.5C11.0794 16.5 7.8335 13.2541 7.8335 9.25C7.8335 5.24594 11.0794 2 15.0835 2C19.0876 2 22.3335 5.24594 22.3335 9.25Z"
        stroke="#0B0C17"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00568 7.67218C8.51362 7.55945 9.04162 7.5 9.5835 7.5C13.5876 7.5 16.8335 10.7459 16.8335 14.75C16.8335 15.2919 16.774 15.8199 16.6613 16.3278C16.1534 16.4406 15.6254 16.5 15.0835 16.5C11.0794 16.5 7.8335 13.2541 7.8335 9.25C7.8335 8.70812 7.89295 8.18012 8.00568 7.67218Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
